import { paramValidatorError } from './errors';
export var itemDataValidatorError = paramValidatorError('itemData', "must be on object with string as value, for example: { \"slug\": \"shoes\" }");
export var itemDataValidator = function (itemData) {
    var typeofKey = typeof itemData;
    if (typeofKey !== 'object' ||
        !itemData ||
        !Object.values(itemData).every(function (item) { return typeof item === 'string'; }) ||
        Array.isArray(itemData)) {
        return itemDataValidatorError;
    }
};
//# sourceMappingURL=item-data.js.map